function init() {
	setGlobalVariables();
}

function setGlobalVariables() {
	setContainerMarginVariable();
	setRealVhValue();
	setMainContentTopPadding();

	var initialWidth = window.utils.screen.width;

	window.addEventListener("resize", () => {
		if (initialWidth !== window.innerWidth) {
			initialWidth = window.innerWidth;
			setContainerMarginVariable();
			setRealVhValue();
			setMainContentTopPadding();
		}
	});
}

function setMainContentTopPadding(){
	var mainContent = document.querySelector("#main-content");
	if(mainContent){
		var header = document.querySelector("#main-header");
		if(header){
			var headerHeight = header.offsetHeight;
			mainContent.style.paddingTop = `${headerHeight}px`;
		}
	}
}

function setContainerMarginVariable() {
	var container = document.querySelector(".container");
	if (container) {
		var style = container.currentStyle || window.getComputedStyle(container),
			marginLeft = style.marginLeft,
			width = style.width;

		if (!marginLeft) {
			marginLeft = 0;
		}

		document.documentElement.style.setProperty(
			"--smx-container-margin",
			`${marginLeft}`
		);
		document.documentElement.style.setProperty(
			"--smx-container-margin-negative",
			`-${marginLeft}`
		);
		document.documentElement.style.setProperty(
			"--smx-container-width",
			`${width}`
		);
	}
}

function setRealVhValue() {
	let vh = window.innerHeight * 0.01,
		body = document.querySelector("body");
	body.style.setProperty("--vh", `${vh}px`);
}

export default { init };
